module.exports = __webpack_public_path__ + "static/media/blackArrowDown.3f7af344.svg";